import { Constants } from '@hvf/contracts'
import * as v from 'valibot'

export const PostSchema = v.pipe(
	v.object({
		title: v.pipe(
			v.string(),
			v.minLength(1, 'Title is required'),
			v.maxLength(200, 'Title must be less than 200 characters'),
		),
		topic: v.picklist(Constants.public.Enums.go_read_topic),
		content: v.pipe(
			v.string(),
			v.minLength(1, 'Content is required'),
			v.maxLength(10000, 'Content must be less than 10000 characters'),
		),
	}),
)

export type PostForm = v.InferInput<typeof PostSchema>
